import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { sMe, sLogin, sRegister, sLogout, getSToken } from "./studentApi";

const Ctx = createContext(null);
export const useStudentAuth = () => useContext(Ctx);

export const StudentAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=student
  const check = useCallback(async () => {
    if (!getSToken()) return setUser(false);
    try { setUser(await sMe()); } catch { setUser(false); }
  }, []);
  useEffect(() => { check(); }, [check]);

  const login = async (e, p) => { const u = await sLogin(e, p); setUser(u); return u; };
  const register = async (b) => { const u = await sRegister(b); setUser(u); return u; };
  const logout = async () => { await sLogout(); setUser(false); };
  return <Ctx.Provider value={{ user, setUser, login, register, logout, refresh: check }}>{children}</Ctx.Provider>;
};

export const StudentProtected = ({ children }) => {
  const { user } = useStudentAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-navy text-white"><Loader2 className="h-8 w-8 animate-spin text-orange" /></div>;
  if (!user) return <Navigate to="/student/login" replace />;
  return children;
};
